module.exports = __webpack_public_path__ + "img/audio_on_button.e722d3eb.svg";